import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Mapping } from "@pienso/ingest-types/pif.interface";

export interface ContentColumn {
  colId: string;
  name: string;
}

/**
 * This service could be much smarter but for now it's the bare minimum needed
 * to share information between various training data page components.
 * Eventually it might be nice to move some of the logic from TrainingDataComponent here.
 */
@Injectable({ providedIn: "root" })
export class TrainingDataService {
  private _contentCol$ = new BehaviorSubject<ContentColumn | null>(null);
  private _mapping$ = new BehaviorSubject<Mapping | null>(null);

  public get contentCol() {
    return this._contentCol$.getValue();
  }
  public set contentCol(col: ContentColumn | null) {
    this._contentCol$.next(col);
  }

  public get mapping$() {
    return this._mapping$.asObservable();
  }
  public get mapping() {
    return this._mapping$.getValue();
  }
  public set mapping(mapping: Mapping | null) {
    this._mapping$.next(mapping);
  }

  reset() {
    this.contentCol = null;
    this.mapping = null;
  }
}
